import Lookup from 'src/componentes/select2';

const DetalhamentoFinanceiroEstagioLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/DetalhamentoFinanceiroEstagioLookup"
    clearable={true}
    {...rest}
  />
);

export default DetalhamentoFinanceiroEstagioLookup;
